<template>
  <div class="comment__idea-converted-card">
    <router-link
      :to="{ name: 'Item', params: { itemId: itemSequenceNumber } }"
      class="comment__idea-converted-card__number"
    >
      <BaseSubHeading
        size="medium"
        weight="500"
      >
        #{{ itemSequenceNumber }}
      </BaseSubHeading>
    </router-link>
    <div class="comment__idea-converted-card__item-title">
      <span
        v-if="itemLabel"
        class="custom-label comment__idea-converted-card__label"
      >
        {{ itemLabel }}
      </span>
      <BaseSubHeading
        size="medium"
        weight="400"
        color="monochrome-07"
        class="comment__idea-converted-card__title"
      >
        {{ itemTitle }}
      </BaseSubHeading>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"

import { Comment } from "@/models"

const props = defineProps<{
  comment: Comment
}>()

const itemSequenceNumber = computed(() => props.comment.ideaAuditRecord?.after?.itemSequenceNumber)
const itemLabel = computed(() => props.comment.ideaAuditRecord?.after?.itemLabel ?? "")
const itemTitle = computed(() => props.comment.ideaAuditRecord?.after?.itemTitle ?? "")
</script>
